import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/customer-api-key';

export const initialState = {
  ...resourceState,
};

export default resourceReducerFactory(initialState, types);
